import axios from '@/configs/Axios'

const payloadParams = (payload) => {
    if(payload) {
        let reqData = "";
        Object.keys(payload).forEach(key => {
            reqData += key + "=" + payload[key] + "&"
        })
        reqData = reqData.substr(0, reqData.lastIndexOf("&"))
        return '?'+reqData
    } else return ''
}

const queryCheck = (query, keys) => {
    let queryFilter = {}
    if(query) {
        for (const key in query) {
            keys.forEach(item => {
                if(key === item) queryFilter[item] = query[key]
            })
        }
        return payloadParams(queryFilter)
    } return ''
}

const state = () => ({
    journalList: [],
    study_year: [],
    acad_period: [],
    cathedra: [],
    teacher: [],
    discipline: [],
    status: [
        {
            uid: 0,
            name: 'closed',
            isStatus: true
        },
        {
            uid: 1,
            name: 'open',
            isStatus: true
        }
    ],
    start_date_end_date:null,
    check_true:[],
    check_false:[],
})
const getters = {
    start_date_end_date: s => s.start_date_end_date,
    check_element_check_true(state){
        return state.check_true
    },
    check_element_check_false(state){
        return state.check_false
    },

}
const mutations = {
    SET_START_DATE_END_DATE(state, value){
        state.start_date_end_date = value
        if (value.check_hoe){
            state.check_true.push(value.check_hoe)
        }else{
            state.check_false.push(value.check_hoe)
        }

    },
    CHANGE_STATUS(state, value) {
        state.journalList[value.index].closed = value.status
        state.journalList[value.index].edited = !state.journalList[value.index].edited
    },
    PUSH_JOURNAL_LIST(state, value) {
        state.journalList = state.journalList.concat(value);
    },
    CLEAR_JOURNAL_LIST(state) {
        state.journalList = []
    },
    SET_SELECT_FILTER(state, payload) {
        state[payload.key] = payload.value
    },
    CLEAR_FILTER_BY_KEY(state, payload) {
        payload.forEach(key => {
            state[key] = []
        })
    },
    CLEAR_SELECT_LIST(state, key) {
        state[key] = []
    }
}

const actions = {
    fetchJournalList ({ commit }, payload) {
        return new Promise((resolve, reject) => {

            const query = {
                page: payload.page,
                ...payload.route.query
            }

            axios.get(`/admin/journals/${ payloadParams(query) }`)
                .then(({data}) => {
                    if(typeof data === 'object') {
                        commit('PUSH_JOURNAL_LIST', data.results)
                        resolve(data)
                    } else resolve(false)
                })
                .catch((error) => { reject(error) })
        })
    },
    checkSelectType({commit, state}, payload) {
        return new Promise((resolve, reject) => {

            let endpoint,
                getParams = '';

            switch(payload.type) {
                case 'study_year':
                    endpoint = '/common/study_years/'
                    break;
                case 'cathedra':
                    endpoint = '/admin/cathedras/'
                    break;
                case 'teacher':
                    getParams = queryCheck(payload.query, ['study_year', 'cathedra'])
                    endpoint = '/schedules/teachers/'
                    break;
                case 'discipline':
                    getParams = queryCheck(payload.query, ['study_year', 'teacher'])
                    endpoint = '/schedules/disciplines/'
                    break;
                case 'acad_period':
                    endpoint = '/common/acad_periods/'
                    break;
            }

            if(endpoint) {
                if(!state[payload.type].length) {
                    axios.get(`${ endpoint }${ getParams }`)
                        .then(({data}) => {
                            commit('SET_SELECT_FILTER', {key: payload.type, value: data})
                            resolve(data)
                        })
                        .catch((error) => { reject(error) })
                } else
                    resolve(state[payload.type])
            } else
                resolve(state.status)
        })
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
